import { Injectable } from "@angular/core";
import { POSTTYPE } from "app/model/post-type";
import { FormGroup } from "@angular/forms";
import { REGISTER } from "app/model/register.model";
import { CookieService } from "ngx-cookie";

@Injectable()
export class RestrieveCookieService {
  constructor(public cookieService: CookieService,) {}

  patchForm(registerform: FormGroup) {

    registerform.patchValue({
      businessGroup: this.cookieService.getObject("businessGroup"),
      deliverMethodArray: this.cookieService.getObject("deliverMethodArray"), //carefor, before here is a array, so need to return array here,
      ownerinfoArray: this.cookieService.getObject("ownerinfoArray"),
      businessRefArray: this.cookieService.getObject("businessRefArray"),
      financialGroup: this.cookieService.getObject("financialGroup"),
      privacyGroup: this.cookieService.getObject("privacyGroup"),
      declarationGroup:this.cookieService.getObject("declarationGroup"),
      guaranteeGroup: this.cookieService.getObject("guaranteeGroup")
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/register/restrieve.cookie.services.ts